export default "__VITE_ASSET__BP15fx7k__"